<div class="d-flex flex-column justify-content-center">
    <p style="font-size:12px;font-weight: 500;">
        On a scale of 1 to 5, 1 being the lowest, 5 being the best, how would you rate our service?
    </p>
    <div class="row">
        <div class="col-2" *ngFor="let button of buttons; let i = index">
            <button type="button" class="btn btn-outline-primary"
                    (click)="setEduction(i)" style="margin-bottom: 10px;width:42px;height: 42px;"
                    [ngStyle]="{ 'background-color': buttons[i].isClickable ? '#FFFFFF' : '#E4E5E8' }"
            >
                <span [ngStyle]="{ 'color': buttons[i].isClickable ? '#182F7C' : '#333333' }"
                        style="font-size: 22px;font-weight: bold;padding-left: 1px;">
                    {{buttons[i].title}}</span>
            </button>
        </div>
    </div>
</div>
